module.exports = __webpack_public_path__ + "static/media/CLUB-13-KING.d79a4a39.svg";